<template>
	<li>
		<div class="homework__item" :class="rightDates ? 'active' : 'passive'">
			<div class="homework__date"><span class="ico-calendar" uk-tooltip="Дата"></span> <span>{{ date }}</span></div>
			<ul class="homework__trains">
				<li v-for="item in items" :key="item.id" class="homework__train" :class="item.is_done == 1 ? 'homework__train--complete' : ''">
					<div class="homework__base">
						<div class="homework__wrap">
							<div class="homework__content">
								<div class="homework__title">{{ item.homework.template.trainer ? item.homework.template.trainer.title : item.homework.template.params.title }}</div>
								<div class="homework__params">
									<div v-if="item.homework.template.trainer">
										<small>Выполнено:</small>
										{{ item.total }} из {{ item.homework.template.qnt }},
										<small>Статус:</small>
										{{ item.status }}
									</div>
								</div>
							</div>
							<div class="homework__button">
								<button v-if="item.homework.template.trainer" @click="checkStudent(item)" :disabled="isDisabled(item)">
									<span></span></button>
								<div v-else>
									<button class="qst" @click="showAlert(item)">?</button>
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</li>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert';
import { mapActions, mapGetters } from 'vuex'


  export default {
    name: "homeworks_item",
    inject: ['http'],
    data() {
      return {
        dates: ''
      }
    },
    props: {
      items: '',
      date: ''
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      currentDate() {
        let date = moment(this.date, 'DD-MM-YYYY');
        return moment().isSame(date, 'day');
      },
      lastDate() {
        let date = moment(this.date, 'DD-MM-YYYY');
        return moment().subtract(1, 'days').isSame(date, 'day');
      },
      rightDates() {
        let date = moment(this.date, 'DD-MM-YYYY');
        if (moment().isSame(date, 'day') || moment().subtract(1, 'days').isSame(date, 'day')) {
          return true;
        }
        return false;
      }
    },
    methods: {
      ...mapActions({
        getHomework: 'student/getHomework'
      }),
      showAlert(item){
        UIkit.modal.dialog(item.homework.template.params.desc);
      },
      isDisabled(item) {
        if ((item.total >= item.homework.template.qnt) || !this.rightDates) {
          return true;
        }
        return false;
      },
      checkStudent(item) {
        this.http.post('onCheckStudent', { homework_id: item.id }).then(res => {
          let auth = res.data.auth_status
          let homework = res.data.homework_status

          if (!auth) {
            location.reload();
            return false
          } else if (!homework) {
            swal('Ошибка', 'Задание не найдено', 'warning')
            this.getHomework(this.user.id)
            return false
          } else {
            this.beginHomework(item)
          }
        })
      },
      buttonText(item) {
        if (item.total > 0) {
          return 'Продолжить'
        }
        return 'Начать';
      },
      beginHomework(item) {
        let component = item.homework.template.trainer.component;
        let params = item.homework.template.params;

        let qnt = item.homework.template.qnt;
        let date = item.date
        params.start = true;
        if (component == 'mnemo') {
          params.start = false;
          params.get_ready = true;
        }
        let data = {
          'train': component + '_params',
          'params': params
        }
        this.$store.commit('train/changeParams', data);
        this.$router.push({
          name: 'trainer',
          params: { 
            component: component, 
            params, 
            isHomework: true, 
            homework_id: item.id, 
            qnt: qnt, 
            total: item.total, 
            date: date
          }
        });      
      }
    },
  }
</script>